/* Maison d'Esteban — „Întrebări frecvente” V1 (P7.5). Îmbunătățire progresivă peste HTML-ul randat de sections/est-faq.liquid:
   căutare live (insensibilă la diacritice) cu evidențiere, filtrare pe categorii, #q-<id> deschide întrebarea,
   săgeți sus/jos/Home/End între întrebări, „/” mută focusul în căutare, eveniment est_faq_open. Fără dependențe. */
(() => {
  const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  // normalizează caracter cu caracter, ca indicii să corespundă textului original (ă/ș/ț/î/â → 1 caracter)
  const normChars = (s) => Array.from(s, (c) => norm(c)[0] || c).join('');
  const fill = (tpl, map) => Object.keys(map).reduce((t, k) => t.split(`[${k}]`).join(map[k]), tpl || '');

  function markText(root, terms) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const text = node.nodeValue;
      const n = normChars(text);
      const on = new Array(text.length).fill(false);
      let any = false;
      terms.forEach((t) => {
        let i = n.indexOf(t);
        while (i > -1) { for (let k = i; k < i + t.length; k++) on[k] = true; any = true; i = n.indexOf(t, i + t.length); }
      });
      if (!any) return;
      const frag = document.createDocumentFragment();
      let buf = '', state = on[0];
      const flush = () => {
        if (!buf) return;
        if (state) { const m = document.createElement('mark'); m.textContent = buf; frag.appendChild(m); } else frag.appendChild(document.createTextNode(buf));
        buf = '';
      };
      for (let i = 0; i < text.length; i++) { if (on[i] !== state) { flush(); state = on[i]; } buf += text[i]; }
      flush();
      node.parentNode.replaceChild(frag, node);
    });
  }

  function init(root) {
    if (root.dataset.estfReady) return;
    root.dataset.estfReady = '1';
    const input = root.querySelector('[data-estf-input]');
    const form = root.querySelector('[data-estf-form]');
    const clear = root.querySelector('[data-estf-clear]');
    const status = root.querySelector('[data-estf-status]');
    const empty = root.querySelector('[data-estf-empty]');
    const list = root.querySelector('[data-estf-list]');
    const chipsNav = root.querySelector('[data-estf-chips]');
    const chips = [...root.querySelectorAll('.estf-chip')];
    const groups = [...root.querySelectorAll('[data-estf-grp]')];
    const items = [...root.querySelectorAll('[data-estf-qa]')].map((el) => {
      const q = el.querySelector('[data-estf-q]');
      const a = el.querySelector('[data-estf-a]');
      const grp = el.closest('[data-estf-grp]');
      return { el, q, a, qHTML: q.innerHTML, aHTML: a.innerHTML, g: grp.dataset.estfGrp,
        hay: normChars(`${q.textContent} ${a.textContent} ${grp.dataset.name} ${el.dataset.kw || ''}`) };
    });
    const D = root.dataset;
    let cat = 'toate';

    // lipește bara de categorii sub antet, dacă antetul temei e lipit sus
    const setTop = () => {
      const h = document.querySelector('#header-group header, #header-component, .header');
      const sticky = h && /sticky|fixed/.test(getComputedStyle(h.closest('[id^="shopify-section"]') || h).position);
      root.style.setProperty('--estf-sticky-top', sticky ? `${Math.round(h.getBoundingClientRect().height)}px` : '0px');
    };
    setTop();

    // categoriile devin butoane de filtrare
    chips.forEach((c) => { c.setAttribute('role', 'button'); c.removeAttribute('aria-current'); c.setAttribute('aria-pressed', String(c.dataset.k === 'toate')); });
    chipsNav.setAttribute('role', 'group');

    const setChip = (k) => {
      cat = k;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.k === k)));
    };

    function render() {
      const raw = input.value.trim();
      const terms = norm(raw).split(/\s+/).filter((t) => t.length > 1);
      clear.hidden = !raw;
      let count = 0;
      items.forEach((it) => {
        it.q.innerHTML = it.qHTML; it.a.innerHTML = it.aHTML;
        const ok = (cat === 'toate' || cat === it.g) && terms.every((t) => it.hay.includes(t));
        it.el.hidden = !ok;
        if (ok) { count++; if (terms.length) { markText(it.q, terms); markText(it.a, terms); } }
      });
      groups.forEach((g) => { g.hidden = !g.querySelector('[data-estf-qa]:not([hidden])'); });
      empty.hidden = count !== 0;
      if (raw) status.textContent = count ? fill(count === 1 ? D.statusOne : D.statusMany, { n: count, q: raw }) : '';
      else if (cat === 'toate') status.textContent = D.statusAll;
      else status.textContent = fill(D.statusCat, { n: count, categorie: (groups.find((g) => g.dataset.estfGrp === cat) || {}).dataset?.name || '' });
      if (terms.length && count && count <= 3) items.forEach((it) => { if (!it.el.hidden && !it.el.open) { it.el.dataset.estfSilent = '1'; it.el.open = true; } });
    }

    let tmr;
    input.addEventListener('input', () => { clearTimeout(tmr); tmr = setTimeout(render, 90); });
    form.addEventListener('submit', (e) => { e.preventDefault(); clearTimeout(tmr); render(); });
    clear.addEventListener('click', () => { input.value = ''; render(); input.focus(); });

    const pick = (c) => { setChip(c.dataset.k); render(); };
    chipsNav.addEventListener('click', (e) => { const c = e.target.closest('.estf-chip'); if (!c) return; e.preventDefault(); pick(c); });
    chipsNav.addEventListener('keydown', (e) => { const c = e.target.closest('.estf-chip'); if (c && e.key === ' ') { e.preventDefault(); pick(c); } });

    document.addEventListener('keydown', (e) => {
      if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
      const t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      e.preventDefault(); input.focus();
    });

    // întrebările deschise: link adânc + eveniment de măsurare
    list.addEventListener('toggle', (e) => {
      const d = e.target;
      if (!d.matches || !d.matches('[data-estf-qa]') || !d.open) return;
      if (!d.dataset.estfSilent) {
        history.replaceState(null, '', `#${d.id}`);
        try { window.Shopify?.analytics?.publish?.('est_faq_open', { id: d.id.replace(/^q-/, '') }); } catch (err) { /* fără pixel */ }
      }
      delete d.dataset.estfSilent;
    }, true);

    // săgeți între întrebările vizibile (tiparul WAI-ARIA accordion)
    list.addEventListener('keydown', (e) => {
      const s = e.target.closest('summary');
      if (!s) return;
      const all = [...list.querySelectorAll('[data-estf-qa]:not([hidden]) > summary')].filter((x) => !x.closest('[hidden]'));
      const i = all.indexOf(s);
      let j = null;
      if (e.key === 'ArrowDown') j = Math.min(i + 1, all.length - 1);
      else if (e.key === 'ArrowUp') j = Math.max(i - 1, 0);
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = all.length - 1;
      if (j !== null) { e.preventDefault(); all[j].focus(); }
    });

    function openFromHash(focus) {
      const id = decodeURIComponent(location.hash.slice(1));
      if (!id.startsWith('q-')) return;
      const el = root.querySelector(`#${CSS.escape(id)}`);
      if (!el) return;
      if (el.hidden) { input.value = ''; setChip('toate'); render(); }
      if (!el.open) { el.dataset.estfSilent = '1'; el.open = true; }
      setTimeout(() => {
        el.scrollIntoView({ block: 'center' });
        if (focus) el.querySelector('summary').focus({ preventScroll: true });
      }, 60);
    }

    root.querySelectorAll('[data-estf-jump]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      history.replaceState(null, '', `#q-${a.dataset.estfJump}`);
      openFromHash(true);
    }));
    window.addEventListener('hashchange', () => openFromHash(false));
    openFromHash(false);
  }

  const boot = () => document.querySelectorAll('[data-estf]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
